export const getAssetByTypeAndSource = (assets, assetType, source) => {
  if (!assets || assets.length === 0) {
    return {}
  }

  return assets.find(asset => asset.assetType === assetType && asset.source === source) || {}
}
